global.conmed = global.conmed || {};

conmed.heroSlider = function ($) {
    'use strict';
    var that = {
        selectors: {
            slider: '.js-hero-slider',
        }
    };

    that.init = function () {
        $(that.selectors.slider).slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: true,
            dots: true
        });
    };

    return that;
}(jQuery);